import React, { useMemo, useState } from "react";
import { MapContainer, Marker, TileLayer, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./mapPicker.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const DEFAULT_CENTER = [-34.6037, -58.3816];

function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) {
      onPick(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
}

export default function MapPickerModal({
  isOpen,
  onClose,
  onConfirm,
  initialLat,
  initialLng,
  title = "Seleccionar coordenadas",
}) {
  const initial = useMemo(() => {
    const lat = Number(initialLat);
    const lng = Number(initialLng);
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      return [lat, lng];
    }
    return DEFAULT_CENTER;
  }, [initialLat, initialLng]);

  const [picked, setPicked] = useState(initial);

  if (!isOpen) return null;

  const handleConfirm = () => {
    console.log(picked[0] + " " + picked[1]);
    onConfirm({ lat: Number(picked[0]), lng: Number(picked[1]) });
    onClose();
  };

  const useCurrentLocation = () => {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => setPicked([coords.latitude, coords.longitude]),
      () => {}
    );
  };

  return (
    <div className="map-picker-overlay" onClick={onClose}>
      <div className="map-picker-modal" onClick={(e) => e.stopPropagation()}>
        <div className="map-picker-header">
          <h4>{title}</h4>
          <button type="button" onClick={onClose}>
            Cerrar
          </button>
        </div>
        <div className="map-picker-coords">
          Lat: {picked[0].toFixed(6)} | Lng: {picked[1].toFixed(6)}
        </div>
        <MapContainer
          center={picked}
          zoom={5}
          className="map-picker-map"
          scrollWheelZoom
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker
            position={picked}
            draggable
            eventHandlers={{
              dragend: (e) => {
                const p = e.target.getLatLng();
                setPicked([p.lat, p.lng]);
              },
            }}
          />
          <ClickHandler onPick={(lat, lng) => setPicked([lat, lng])} />
        </MapContainer>
        <div className="map-picker-actions">
          <button type="button" onClick={useCurrentLocation}>
            Mi ubicación
          </button>
          <button type="button" onClick={handleConfirm}>
            Usar coordenadas
          </button>
        </div>
      </div>
    </div>
  );
}

